<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">医生群统计</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 130px; margin: 0 12px 0 5px"
              @input="search"
              clearable=""
            ></el-input>
            <span>医生手机</span>
            <el-input
              placeholder="请输入"
              v-model="phone"
              style="width: 130px; margin: 0 12px 0 5px"
              @input="search"
              clearable=""
            ></el-input>
            <span>医院</span>
            <el-input
              placeholder="请输入"
              v-model="hospital"
              style="width: 130px; margin: 0 12px 0 5px"
              clearable=""
              @input="search"
            ></el-input>
            <el-button
              type="primary"
              @click="search"
              size="medium"
            >查询</el-button>
            <el-button
              plain
              @click="reSearch"
              size="medium"
            >重置</el-button>
          </div>
        </div>
        <div class="flex_between">
          <span>
            <span style="margin-right: 30px">
              医生人数：
              <span style="color: #669961; font-weight: 700">
                {{ doctor_total }}人</span>
            </span>
            <span>
              总群数：
              <span style="color: #669961; font-weight: 700">
                {{ group_total }}个</span>
            </span>
          </span>
          <el-radio-group
            v-model="is_test"
            size="small"
            @change="search"
          >
            <el-radio-button :label="2">正式</el-radio-button>
            <el-radio-button :label="1">测试</el-radio-button>
          </el-radio-group>
        </div>
        <div style="border: solid 1px #c9cbd6; margin-top: 12px">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="changeOrder"
          >
            <el-table-column label="医生姓名">
              <template slot-scope="scope">
                <span
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >{{scope.row.doctor_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
            ></el-table-column>
            <el-table-column
              prop="hospital"
              label="医院"
            ></el-table-column>
            <el-table-column
              prop="group_total"
              label="群数"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('686')
                      : false
                  "
                  @click="toDetail(scope.row.doctor_id)"
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 30px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      is_test: 2,
      doctor_name: '',
      phone: '',
      hospital: '',
      order: 0,
      doctor_total: 0,
      group_total: 0,
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  components: {
    DocMsg
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        hospital: this.hospital,
        is_test: this.is_test,
        order: this.order
      };
      this.axios
        .post('platform/doctor/getDoctorConsoleGroupTotalList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
            this.doctor_total = res.data.doctor_total;
            this.group_total = res.data.group_total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    changeOrder(value) {
      let order = value.order;
      //升序
      if (order == 'ascending') {
        this.order = 1;
      }
      //降序
      if (order == 'descending') {
        this.order = 2;
      }
      if (!order) {
        this.order = 0;
        this.order_hospital_id = '';
        this.order_drug_type = '';
      }
      this.getList();
    },
    //重置
    reSearch() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.doctor_name = '';
      this.phone = '';
      this.hospital = '';
      this.order = 0;
      this.getList();
    },
    //详情
    toDetail(doctor_id) {
      this.$router.push({
        path: 'groupdetail',
        query: {
          doctor_id
        }
      });
    }
  },

  created() {
    this.getList();
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>